/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActivatePremiumTrialMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type ActivatePremiumTrialMutation = { readonly __typename?: 'Mutation', readonly ActivatePremiumTrial: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly customElementsLimit: number, readonly features: ReadonlyArray<{ readonly __typename?: 'AccountFeatureState', readonly feature: GraphQL.AccountFeature, readonly id: CK.ID }>, readonly premiumTrialOffer: { readonly __typename?: 'AccountPremiumTrialOffer', readonly durationInDays: number, readonly plan: GraphQL.AccountPlan } | null } | null } } };


export const ActivatePremiumTrialDocument = gql`
    mutation ActivatePremiumTrial($accountId: AccountId!) {
  ActivatePremiumTrial(accountId: $accountId) {
    query {
      account(id: $accountId) {
        id
        customElementsLimit
        features {
          feature
          id
        }
        premiumTrialOffer {
          durationInDays
          plan
        }
      }
    }
  }
}
    `;
export type ActivatePremiumTrialMutationFn = Apollo.MutationFunction<ActivatePremiumTrialMutation, ActivatePremiumTrialMutationVariables>;

/**
 * __useActivatePremiumTrialMutation__
 *
 * To run a mutation, you first call `useActivatePremiumTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePremiumTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePremiumTrialMutation, { data, loading, error }] = useActivatePremiumTrialMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useActivatePremiumTrialMutation(baseOptions?: Apollo.MutationHookOptions<ActivatePremiumTrialMutation, ActivatePremiumTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivatePremiumTrialMutation, ActivatePremiumTrialMutationVariables>(ActivatePremiumTrialDocument, options);
      }
export type ActivatePremiumTrialMutationHookResult = ReturnType<typeof useActivatePremiumTrialMutation>;
export type ActivatePremiumTrialMutationResult = Apollo.MutationResult<ActivatePremiumTrialMutation>;
export type ActivatePremiumTrialMutationOptions = Apollo.BaseMutationOptions<ActivatePremiumTrialMutation, ActivatePremiumTrialMutationVariables>;